import { TradingAccountStatus } from 'api/Trading-Accounts/Types/TradingAccountStatus'
import classNames from 'classnames'
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  QuestionCircleOutlined,
} from 'components/Icon'
import { ClientStatusId } from 'utils/clients.helpers'

import styles from './SearchGridResult.module.scss'

interface TradingAccountStatusIconProps {
  statusId: number
}

export const TradingAccountStatusIcon: React.FC<TradingAccountStatusIconProps> = ({ statusId }) => {
  switch (statusId) {
    case TradingAccountStatus.Approved:
      return (
        <span className={classNames(styles.checkCircleIcon)}>
          <CheckCircleOutlined />
        </span>
      )
    case TradingAccountStatus.Declined:
      return (
        <span className={classNames(styles.questionCircleIcon)}>
          <QuestionCircleOutlined />
        </span>
      )
    case TradingAccountStatus.Disabled:
    case TradingAccountStatus.Deleted:
    case TradingAccountStatus.Archived:
    case TradingAccountStatus.ReadOnly:
      return (
        <span className={classNames(styles.deletedCircleIcon)}>
          <CloseCircleOutlined />
        </span>
      )
    default:
      return (
        <span className={classNames(styles.questionCircleIcon)}>
          <QuestionCircleOutlined />
        </span>
      )
  }
}

interface StatusIconFactoryProps {
  statusId: number
}

export const StatusIconFactory: React.FC<StatusIconFactoryProps> = ({ statusId }) => {
  if (statusId === ClientStatusId.PENDING_VERIFICATION) {
    return (
      <span className={classNames(styles.questionCircleIcon)}>
        <QuestionCircleOutlined />
      </span>
    )
  }
  if (statusId === ClientStatusId.EMAIL_VERIFIED) {
    return (
      <span className={classNames(styles.checkCircleIcon)}>
        <CheckCircleOutlined />
      </span>
    )
  }
  if (statusId === ClientStatusId.PENDING_DOCUMENT_VERIFICATION) {
    return (
      <span className={classNames(styles.questionCircleIcon)}>
        <QuestionCircleOutlined />
      </span>
    )
  }
  if (statusId === ClientStatusId.ACTIVATED) {
    return (
      <span className={classNames(styles.checkCircleIcon)}>
        <CheckCircleOutlined />
      </span>
    )
  }
  if (statusId === ClientStatusId.VALIDATION_DENIED) {
    return (
      <span className={classNames(styles.exclamationCircleIcon)}>
        <ExclamationCircleOutlined />
      </span>
    )
  }
  if (statusId === ClientStatusId.BLOCKED) {
    return (
      <span className={classNames(styles.exclamationCircleIcon)}>
        <ExclamationCircleOutlined />
      </span>
    )
  }
  if (statusId === ClientStatusId.DORMANT) {
    return (
      <span className={classNames(styles.questionCircleIcon)}>
        <QuestionCircleOutlined />
      </span>
    )
  }
  return null
}
